import React from 'react';


export default class Footer extends React.Component {
    render() {
       return (<div className="FooterText">
           Past performance is no guarantee of future results; this website is not an offer of securities and securities in FCVC are only offered by a private placement memorandum and only to accredited investors; and start-up investments involve substantial risk and may result in total loss. Some of the investments listed on FCVC.com were made by FundersClub.com, an affiliate of FCVC.
        </div>);
    }
}


export class PageFooter extends React.Component {
    render() {
        return (<div className="PageFooter">
            <Footer/>
        </div>);
    }
}



// WEBPACK FOOTER //
// ./src/components/footer.js